import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { Role } from '../models';
import RouteKey from './key';
import UsefulInformationListing from '../pages/usefulInformation/@candidate/UsefulInformationListing';
import PrivateRoute from '../modules/profile/components/PrivateRoute';

const { error: errorRoute } = RouteKey.child;

const { root: usefulInformation } = RouteKey['useful-information'].child;

const UsefulInformationRoute = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <PrivateRoute exact path={`${path}`} roles={[Role.candidate]}>
        <Redirect to={`${path}/${usefulInformation.route}`} />
      </PrivateRoute>
      <PrivateRoute path={`${path}/${usefulInformation.route}`} roles={[Role.candidate]}>
        <UsefulInformationListing />
      </PrivateRoute>
      <Route path="*" exact>
        <Redirect to={`/${errorRoute}`} />
      </Route>
    </Switch>
  );
};

export default UsefulInformationRoute;
